import { render, staticRenderFns } from "./DetailDesc.vue?vue&type=template&id=5222b989&scoped=true&"
import script from "./DetailDesc.vue?vue&type=script&lang=js&"
export * from "./DetailDesc.vue?vue&type=script&lang=js&"
import style0 from "./DetailDesc.vue?vue&type=style&index=0&id=5222b989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5222b989",
  null
  
)

export default component.exports